<template>
  <v-card class="room-assignment-card mb-4" elevation="0">
    <v-card-title :class="{'primary darken-2 white--text': !!assignment}"><v-icon left color="white">mdi-home-city</v-icon>
      {{assignment ? 'Hostel Assignment' : 'Hostel Selection'}}</v-card-title>
    <v-card-text v-if="assignment" class="">
      <student-space-information :assignment="assignment"></student-space-information>
    </v-card-text>
    <enhanced-room-selection v-else :interest="interest" @assigned="e => assignment = e"></enhanced-room-selection>
  </v-card>
</template>

<script>
import EnhancedRoomSelection from "@/student/components/hostel/RoomSelection.vue";
import StudentSpaceInformation from "@/student/components/hostel/StudentSpaceInformation.vue";

export default {
  name: 'HostelAssignmentCard',
  components: {StudentSpaceInformation, EnhancedRoomSelection},

  props: {
    assignment: {
      type: Object,
      default: null
    },
    interest: {
      type: [Object, null],
      default: null
    }
  }
};
</script>

<style>
.room-assignment-card {
  position: relative;
  overflow: hidden;
  transition: transform 0.3s;
}

.room-assignment-card:hover {
  transform: translateY(-2px);
}

.assignment-item {
  transition: background-color 0.2s;
  border-radius: 4px;
}

.assignment-item:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.status-chip {
  position: absolute;
  top: 12px;
  right: 12px;
}

.v-list-item-icon {
  margin-right: 16px;
}

.v-avatar {
  transition: transform 0.2s;
}

.assignment-item:hover .v-avatar {
  transform: scale(1.1);
}
</style>
